export default {
  newDesign: true,
  title:
    "Haz el test y arma una rutina diaria que ayude a tu hijo a concentrarse mejor | Kodland",
  downtimeUrl: "http://kodland.org/es",
  parameters: {
    landing_id: "EsQuDisPaid",
    segment: 14,
    success_page: "success_long",
  },
  startPage: {
    title:
      "Responde 5 preguntas sobre tu hijo y recibe recomendaciones para armar una rutina diaria que lo ayude a enfocarse más y formar buenos hábitos 💙",
    subtitle:
      "Hay niños que se sientan a hacer la tarea y 5 minutos después ya están saltando por toda la casa. Se distraen con cualquier cosa y olvidan lo que les pediste.<br>No es flojera, ni falta de interés 💪<br>Podemos ayudarles creando hábitos útiles para mejorar su concentración 🎯",
    image: {
      url: "/welcome/es_content_distraction_paid_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/es_content_distraction_paid_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "¡Empieza ahora! 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Cuántos años tiene tu hijo?",
      answers: [
        "Menos de 5 👶",
        "Entre 5 y 7 🧒",
        "Entre 8 y 12 👦",
        "Más de 13 👧",
      ],
    },

    2: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 1, answer: "Menos de 5 👶" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/es_content_distraction_paid_q2.png",
            subtitle:
              "Recomendaciones de los expertos:<br> 🛏️ Dormir y despertar a la misma hora (11–13 h de sueño) regula su cuerpo y ánimo.<br>🤸 Juegos físicos diarios (30–60 min) mejoran atención y control corporal.<br>🧺 Tareas simples con instrucciones claras fortalecen la memoria.<br>🎨 Actividades tranquilas como dibujar o usar plastilina desarrollan concentración y paciencia.",
            button: "¡Perfecto!",
          },
        },
        {
          condition: [{ step: 1, answer: "Entre 5 y 7 🧒" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/es_content_distraction_paid_q2.png",
            subtitle:
              "Recomendaciones de los expertos:<br>🕘 Rituales para empezar y terminar el día dan estructura y seguridad.<br>✅ Usa checklists o tarjetas visuales para organizar y recordar tareas.<br>🧩 Actividades sin pantallas (como LEGO o dibujo) ayudan a calmarse y enfocarse.<br>🕺 Pausas físicas entre tareas facilitan el cambio de actividad sin estrés.<br>🌟 Mini-recompensas por tareas completadas refuerzan la motivación y el autocontrol.",
            button: "¡Perfecto!",
          },
        },
        {
          condition: [{ step: 1, answer: "Entre 8 y 12 👦" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/es_content_distraction_paid_q2.png",
            subtitle:
              "Recomendaciones de los expertos:<br>🏃 Moverse antes de estudiar ayuda a liberar tensión y enfocarse mejor.<br>⏳ Prueba la técnica Pomodoro (25/5 min) para entrenar la atención.<br>📓 Un diario o tracker de logros refuerza su autoestima y el sentido de progreso.<br>📵 Menos pantallas antes de dormir = mejor descanso y mente clara.<br>💬 Dale retroalimentación sin presión para fomentar su autogestión.",
            button: "¡Perfecto!",
          },
        },
        {
          condition: [{ step: 1, answer: "Más de 13 👧" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/es_content_distraction_paid_q2.png",
            subtitle:
              "Recomendaciones de los expertos:<br>🖊️ Escribir a diario (en un diario o checklist) ayuda a procesar emociones y planear.<br>🏋️ Hacer ejercicio 3–5 veces por semana reduce la ansiedad y mejora la concentración.<br>🧘 Un poco de mindfulness diario calma la mente y mejora la atención.<br>📅 Usar un planner o app para organizarse da sensación de control.",
            button: "¡Perfecto!",
          },
        },
      ],
    },
    3: {
      question:
        "¿Qué es lo que más te frustra o te preocupa del comportamiento de tu hijo?",
      answers: [
        "Se distrae con todo y no puede quedarse quieto. 🌀",
        "Pierde cosas todo el tiempo y se le olvidan hasta lo más simple. 🧠",
        "Le cuesta llevarse bien con otros niños o hacer amigos. 👥",
        "Es muy terco, no obedece y rompe las reglas 🚫",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q4.png",
      subtitle:
        "¡Gracias por compartir! 💙 Cada niño es diferente y necesita un enfoque único, pero aquí tienes un buen punto de partida para ayudarlo desde casa.",
      button: "Ver más consejos útiles 👀!",
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q5.png",
      button: "Todo claro 👌",
    },
    6: {
      question: "¿Tu hijo pasa mucho tiempo frente a la pantalla?",
      answers: [
        "Sí, aprovecha cualquier momento libre para usarlas.📱",
        "No, solo las usa para tareas y a veces para divertirse. 📘",
        "Intentamos controlar el tiempo, pero no le gusta mucho la idea. ⏳",
        "No tenemos computadora ni dispositivos en casa 🤔",
      ],
    },
    7: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q7.png",
      subtitle:
        "Aquí te traremos recomendaciones de la OMS sobre el uso de pantallas (fuera del colegio):",
      button: "¿Y cómo se logra eso en la vida real? 👉",
    },
    8: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q8.png",
      subtitle:
        "¿Cómo reducir el tiempo frente a pantallas sin peleas?<br>⏲️ Usa temporizadores: por ejemplo, 20 minutos de YouTube y luego una pausa.<br>📅 Agenda momentos sin pantallas: salir a caminar, jugar, leer o ayudar en casa.<br>👀 Sé el ejemplo: si tú estás todo el día con el celular, tu hijo también lo hará.",
      button: "¡Buena idea!🙌",
    },
    9: {
      question:
        "¡No todo son problemas! ¿Cuál dirías que es la “superhabilidad” de tu hijo?",
      answers: [
        "Creatividad 🎨",
        "Habilidad para las ciencias exactas 🔬",
        "Carisma 😎",
        "Seguridad en sí mismo💪",
      ],
    },
    10: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q10.png",
      subtitle:
        "¡Genial! Intenta incluir actividades que refuercen sus talentos para darle más alegría, confianza y motivación en el día a día.",
      button: "Lo añadimos 💟",
    },
    11: {
      question: "¿Tu hijo tiene algún hobby o actividad extraescolar?",
      answers: [
        "No, solo va al colegio 🏫",
        "Sí, va a un taller artístico o deportivo ⚽",
        "Tiene un hobby, pero no va a clases extra 🎮",
        "¡Tiene muchas actividades! Tratamos de hacer de todo 📚",
      ],
    },
    12: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q12.png",
      subtitle:
        "Para niños con dificultades de atención, lo más importante no es hacer mil cosas, sino mantener la constancia y que realmente les interese 🤩<br>🏃‍♂️ Incluye actividades físicas: juegos, baile, natación o yoga para niños.<br>🎯 Motiva con curiosidad, no con presión.<br>📋 Busca clases con pasos repetitivos y profes con paciencia.<br>🌟 Lo ideal: que elija lo que le gusta y tú lo acompañes sin soltarle la mano, eso entrena seguir instrucciones y no rendirse fácil.",
      button: "Sigue y recibe algo útil para tu hijo 🎁",
    },
    13: {
      question:
        "¿Tienes una computadora de escritorio o portátil en la que tu hijo puede jugar o estudiar?",
      answers: [
        "Si ✅",
        {
          answer: "☹️ No",
          stopAnswer: true,
        },
      ],
    },
    14: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      button: "",
    },
    15: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/es_content_distraction_paid_q15.png",
      subtitle:
        "Este test fue creado por expertos de Kodland, escuela online donde los niños aprenden programación y tecnología de forma divertida.<br>Te invitamos a una clase de prueba gratuita: 100% online, en vivo y con profesor 🎁<br>Tu hijo explorará la programación desarrollando concentración y pensamiento lógico.<br>Regístrate y elige tu horario. Nos vemos en clase 🚀",
      button: "Reservar mi clase gratuita 🔥",
    },
    16: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Elige una fecha ➡️",
    },
    17: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    18: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    19: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    20: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
